<script setup lang="ts">
  import { computed } from "vue";
  import { storeToRefs } from "pinia";
  import { Loader2, RotateCcw } from "lucide-vue-next";
  import { useChatPagesStore } from "@/stores/chatPages";
  import { useToastsStore } from "@/stores/toastsStore";
  import { Button } from "@/components/ui/button";

  const store = useChatPagesStore();
  const toast = useToastsStore();
  const { customizedChatPage, previewCustomisation, savingCustomisation } = storeToRefs(store);

  // The chat publishes its theme as soon as it renders, so Save stays disabled
  // only while it is still loading.
  const canSave = computed(() => Boolean(customizedChatPage.value && previewCustomisation.value));

  const save = async () => {
    try {
      await store.saveCustomisation();
      toast.success("Theme saved. It now applies to every link using this page.");
    } catch {
      toast.error("Failed to save the theme");
    }
  };

  const reset = () => {
    store.resetCustomisation();
    toast.success("Theme reset to the last saved state");
  };
</script>

<template>
  <div class="flex items-center gap-2">
    <span class="text-xs text-muted-foreground">Open the palette button to customize, then save</span>
    <Button
      variant="outline"
      size="sm"
      :disabled="savingCustomisation"
      @click="reset">
      <RotateCcw class="mr-1.5 h-3.5 w-3.5" />
      Reset
    </Button>
    <Button
      size="sm"
      :disabled="!canSave || savingCustomisation"
      @click="save">
      <Loader2
        v-if="savingCustomisation"
        class="mr-1.5 h-4 w-4 animate-spin" />
      Save
    </Button>
  </div>
</template>
